// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__14XuK","name":"ConsentHeader_name__r8jmT","birthday":"ConsentHeader_birthday__2yrt-","skeleton":"ConsentHeader_skeleton__36mHh"};